import styled from 'styled-components';
import ActTag01 from 'dc/ActTag01';
import IcoW01 from 'dc/IcoW01';

type ContainerProps = {
  $expanded: boolean;
  $expandedHeight: string;
};

export const Container = styled.div<ContainerProps>`
  position: relative;
  width: calc(100% - 32px);
  height: ${props => (props.$expanded ? props.$expandedHeight : '30px')};
  overflow: hidden;
  margin: 16px;
  transition: height ease-out 0.2s;
`;

export const Icon = styled(IcoW01)`
  position: absolute;
  top: -12px;
  right: -12px;
`;

export const TagWrapper = styled.div`
  width: calc(100% - 36px);
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const Tag = styled(ActTag01)``;
